import type { ITabsContainerProps } from './TabsContainer'

import { styled } from '@linaria/react'
import { WrapperControls } from 'blocks/Container/Controls'
import { COLOR, FIXED_INDENTS, LAYOUT } from 'vars/index'
import { TabControlsType } from './TabsContainer.h'

export const TabsContainerStyled = styled.div<
  Omit<ITabsContainerProps, 'list' | 'nodeRef'> & {
    isTablet: boolean
    isScrolling: boolean
  }
>`
  position: relative;
  display: flex;
  width: 100%;
  padding: ${({ paddings }) =>
    paddings!.map((padding) => `var(${padding})`).join(' ')};
  padding-left: ${({ isTablet, paddings }) =>
    isTablet
      ? `var(${LAYOUT.HorizontalPaddings})`
      : paddings && paddings.length > 1
        ? `var(${paddings[1]})`
        : 'initial'};
  padding-right: ${({ isTablet, paddings }) =>
    isTablet
      ? `var(${LAYOUT.HorizontalPaddings})`
      : paddings && paddings.length > 1
        ? `var(${paddings[1]})`
        : 'initial'};
  background: ${({ backgroundColor }) =>
    `var(${backgroundColor || COLOR.TRANSPARENT})`};

  a {
    color: inherit;
  }

  > ${WrapperControls} {
    position: absolute;
    cursor: pointer;
    height: auto;
    top: ${({ paddings = [FIXED_INDENTS.INDENT_0] }) => `var(${paddings[0]})`};
    left: 0;
    width: 100%;
    display: block;

    & > :first-child,
    & > :last-child {
      position: absolute;
      top: ${({ controlsType }) =>
        controlsType === TabControlsType.inRow ? '20%' : 0};
      transform: ${({ controlsType }) =>
        controlsType === TabControlsType.inRow ? 'translateY(80%)' : 0};
      height: auto;
      z-index: 2;
    }

    & > :first-child {
      left: ${({ controlsType }) =>
        controlsType === TabControlsType.inRow ? '24px' : 0};
    }

    & > :last-child {
      right: ${({ controlsType }) =>
        controlsType === TabControlsType.inRow ? '24px' : 0};
    }
  }
`
